import { render, staticRenderFns } from "./CompanyDetails.vue?vue&type=template&id=6f4d5ce0&scoped=true"
import script from "./CompanyDetails.vue?vue&type=script&lang=ts"
export * from "./CompanyDetails.vue?vue&type=script&lang=ts"
import style0 from "./CompanyDetails.vue?vue&type=style&index=0&id=6f4d5ce0&lang=scss"
import style1 from "./CompanyDetails.vue?vue&type=style&index=1&id=6f4d5ce0&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f4d5ce0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/sandeep/Work/EIOSYS/Cona-OSUM/Cona-Electrical-Admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6f4d5ce0')) {
      api.createRecord('6f4d5ce0', component.options)
    } else {
      api.reload('6f4d5ce0', component.options)
    }
    module.hot.accept("./CompanyDetails.vue?vue&type=template&id=6f4d5ce0&scoped=true", function () {
      api.rerender('6f4d5ce0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/companies/components/CompanyDetails.vue"
export default component.exports